import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ContainerMd from "../../components/Layouts/ContainerMd";
import { useMutation } from "react-query";
import { updateStudent } from "../../api/endpoints/students/students";
import ToastNottfication from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";
import AppLogo from "../../components/AppLogo";
import {
  STUDENT_STEPS,
  TUTOR_INFO_STEP_INDEX,
} from "../complete-account/completeAccountUtils";
import ChangeLangButton from "../../components/language/ChangeLangButton";
import { useAuth } from "../../context/AuthContext";
import { useTelawah } from "../../hooks/useTelawah";

function StudentTutorInfoPage() {
  const userContext = useAuth();
  const { telawahs } = useTelawah();
  const LocalBasePath = "page.student.tutorInfo";
  const { t, i18n } = useTranslation("", { keyPrefix: LocalBasePath });

  const navigate = useNavigate();

  const [reading, setReading] = useState<null | string>(null);
  const [sex, setSex] = useState<null | string>(null);

  const {
    mutateAsync: saveStudentDate,
    isLoading,
    isError,
  } = useMutation(updateStudent, {
    onSuccess: () => navigate("/student/dashboard/"),
  });
  const onPressDone = async () => {
    await saveStudentDate({
      telawah_id: reading,
      tutor_gender_preference:
        userContext?.currentUser?.gender === "female" ? sex : "male",
    });
  };
  const prevPage = async () => {
    navigate(STUDENT_STEPS[TUTOR_INFO_STEP_INDEX - 1].route);
  };
  let submitButtonText = i18n.t(`page.freeTime.save`);

  let stepInfo = `${TUTOR_INFO_STEP_INDEX + 1} ${i18n.t("page.steps.of")} ${
    STUDENT_STEPS.length
  }`;
  let prevButton = `${i18n.t("page.steps.previous")}:${i18n.t(
    STUDENT_STEPS[TUTOR_INFO_STEP_INDEX - 1].name
  )}`;

  const Spinner = () => {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <LoadingSpinner size={16} />
      </div>
    );
  };
  return (
    <ContainerMd className={"min-h-[80vh]"}>
      {isError && <ToastNottfication massgesKey={t("error")} type="error" />}
      <div className="w-full flex md:flex-row flex-col justify-between  items-center">
        <AppLogo className="mb-4 " />
        <div className="flex-shrink-0 self-center">
          <ChangeLangButton dropDownLanguage={true} />
        </div>
      </div>
      <div className="pt-8 border-t border-gray-200">
        <h3 className="text-lg leading-6 font-medium text-gray-900">
          {t("readingInfo")}
        </h3>
        <p className="mt-1 max-w-2xl text-sm text-gray-500">
          {t("selectReading")}
        </p>
      </div>
      <div className="pb-8">
        <div className="pt-5">
          <label
            htmlFor="reading"
            className="mb-1 block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
          >
            {t("reading")}
          </label>
          <div className="mt-2 sm:mt-0 sm:col-span-2">
            <select
              data-cy="reading-select"
              id="reading"
              defaultValue=""
              name="reading"
              onChange={(e) => {
                setReading(e.target.value);
              }}
              className="max-w-lg block focus:ring-brandblue-500 focus:border-brandblue-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 disabled:text-blue-500 rounded-md"
            >
              <option value="" disabled hidden>
                {t("chooseToRead")}
              </option>
              {telawahs?.map((telawah) => (
                <option value={telawah.id} key={`Telawah_${telawah.name}`}>
                  {telawah.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        {userContext?.currentUser?.gender === "female" && (
          <div className="pt-5">
            <label
              htmlFor="gender"
              className="mb-1 block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
            >
              {t("theGenderOfTheReciter")}
            </label>
            <div className="mt-2 sm:mt-0 sm:col-span-2">
              <select
                data-cy="gender-select"
                id="gender"
                name="gender"
                defaultValue=""
                onChange={(e) => {
                  setSex(e.target.value);
                }}
                className="max-w-lg block focus:ring-brandblue-500 focus:border-brandblue-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
              >
                <option value="" disabled hidden>
                  {t("noPreference")}
                </option>
                <option value={"female"}>{t("female")}</option>
                <option value={"male"}>{t("male")}</option>
              </select>
            </div>
          </div>
        )}
      </div>
      <div className=" w-full border-t border-gray-200 py-5 sticky bottom-0 bg-white flex justify-between items-center flex-col-reverse sm:flex-row gap-4">
        <div>
          <button
            onClick={() => prevPage()}
            className="flex justify-center flex-shrink-0 py-2 px-4 border border-gray shadow-sm text-sm font-medium rounded-md text-gray bg-transparent  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500 disabled:bg-gray-400"
          >
            {prevButton}
          </button>
        </div>
        <div className="flex md:flex-row flex-col items-center gap-4 justify-end">
          <div className="w-full flex md:justify-end justify-center  text-sm font-medium text-gray-700">
            {stepInfo}
          </div>
          <button
            data-cy="save-button"
            onClick={() => onPressDone()}
            disabled={!reading}
            type="submit"
            className="flex justify-center flex-shrink-0 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500 disabled:bg-gray-400"
          >
            {isLoading ? <Spinner /> : submitButtonText}
          </button>
        </div>
      </div>
    </ContainerMd>
  );
}
export default StudentTutorInfoPage;
